import cx from 'clsx';
import * as React from 'react';

import { QuicksilverTileOutfitType } from '@/components/game-tile/types';

import styles from './SashLayer.module.scss';

interface SashLayerProps {
  sash?: string;
  background: string;
  outfit: QuicksilverTileOutfitType;
}

const SashLayer = ({ sash, background, outfit }: SashLayerProps) => {
  if (!sash) return null;
  return (
    <div
      className={cx(styles.container, {
        [styles.containerSmall]: outfit === 'small',
      })}
      style={{ background: background }}
      data-testid="sash-wrapper"
    >
      <span
        className={cx(styles.text, { [styles.textSmall]: outfit === 'small' })}
        data-testid="sash-text"
      >
        {sash}
      </span>
    </div>
  );
};

export default SashLayer;
